export const GENERAL_FAQ = [
  {
    question: "What is sleep apnea and how does it affect health?",
    answer:
      "Sleep apnea is a condition where breathing repeatedly stops during sleep due to airway blockage. It can lead to poor sleep quality, fatigue, high blood pressure, and long-term health complications if untreated."
  },
  {
    question: "What are the common signs of sleep apnea?",
    answer:
      "Common signs include loud snoring, mouth breathing, daytime sleepiness, morning headaches, poor concentration, and disturbed sleep. In children, it may appear as hyperactivity or poor school performance."
  },
  {
    question: "Can sleep apnea be treated without surgery?",
    answer:
      "Yes. Many cases can be treated using non-surgical methods like oral appliances, myofunctional therapy, and MARPE. Surgery such as DOME is only recommended in advanced cases."
  },
  {
    question: "What is Myofunctional Therapy?",
    answer:
      "Myofunctional therapy is a set of exercises that retrain the tongue and facial muscles to improve breathing, oral posture, and sleep quality. It is often used as part of sleep apnea treatment."
  },
  {
    question: "Can myofunctional therapy help with snoring and sleep apnea?",
    answer:
      "Yes. It helps strengthen airway muscles, promotes nasal breathing, and reduces snoring. It is effective for mild to moderate sleep apnea and supports long-term results."
  },
  {
    question: "What is MARPE and how does it help sleep apnea?",
    answer:
      "MARPE (Mini-implant Assisted Rapid Palatal Expansion) is a non-surgical treatment that widens the upper jaw to improve airway space. It is commonly used in adults with narrow jaws and sleep apnea."
  },
  {
    question: "What is DOME treatment for sleep apnea?",
    answer:
      "DOME (Distraction Osteogenesis Maxillary Expansion) is a surgical procedure used to expand the upper jaw in adults with severe airway restriction. It provides significant and predictable improvement in sleep apnea."
  },
  {
    question: "MARPE vs DOME – which is better?",
    answer:
      "MARPE is a non-surgical option suitable for mild to moderate cases, while DOME is used for severe sleep apnea or when greater airway expansion is required."
  },
  {
    question: "Is sleep apnea treatment suitable for children?",
    answer:
      "Yes. Early treatment helps guide proper jaw development, improve breathing, and prevent future sleep apnea. Children respond very well to airway-focused treatments."
  },
  {
    question: "How long does sleep apnea treatment take?",
    answer:
      "Treatment duration varies depending on the approach. Myofunctional therapy may take 8–16 weeks, while jaw expansion treatments like MARPE or DOME may take several months."
  },
  {
    question: "Is sleep apnea treatment painful?",
    answer:
      "Most treatments are non-invasive and comfortable. Therapies focus on gradual improvement, airway support, and habit correction."
  },
  {
    question: "What is TMJ disorder and is it related to sleep apnea?",
    answer:
      "TMJ disorder affects the jaw joint and can cause pain, clicking, and headaches. In some cases, it is linked to airway problems and sleep apnea due to improper jaw positioning."
  }
];